import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    sancionesAdministrativas: [],
  },

  getters: {
    getSancionesAdministrativas: (state) => state.sancionesAdministrativas,
  },

  mutations: {
    SET_SANCIONES_ADMINISTRATIVAS(state, sancionesAdministrativas) {
      state.sancionesAdministrativas = sancionesAdministrativas;
    },
  },

  actions: {
    async fetchSancionesAdministrativas({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/C3/personal/${idPersonal}/sancionesAdministrativas`)
        .then((response) => {
          commit('SET_SANCIONES_ADMINISTRATIVAS', response.data.data);
        });
    },

    async saveSancionesAdministrativas(_, sancionesAdministrativas) {
      await axios
        .post(`PoliciaCuadrantes/C3/personal/${sancionesAdministrativas.fk_idPersonal}/sancionesAdministrativas`, sancionesAdministrativas);
    },

    async updateSancionesAdministrativas(_, sancionesAdministrativas) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/personal/${
            sancionesAdministrativas.fk_idPersonal
          }/sancionesAdministrativas/${
            sancionesAdministrativas.fk_idSancionesAdministrativas}`,
          sancionesAdministrativas,
        );
    },
  },
};
